<template>
  <div :class="shouldDisplayError ? [`m3p-form__errorbox`] : null">
    <selector-field
      class="m3p-select m3p-form__strong"
      :name="fieldName"
      :id="fieldName"
      :options="selectivePrefectureList"
      :validator="validator"
      :dispatcher="dispatcher"
    >
      <template #select="props">
        <option :value="null" disabled>都道府県（必須）</option>
        <option
          v-for="item in props.options"
          :value="item.value"
          :key="item.value"
          >{{ item.text }}</option
        >
      </template>
    </selector-field>
    <error-message :name="fieldName" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useFieldError } from 'vee-validate';
import ErrorMessage from '@component_path/pages/pc/positions/show/common_components/form_element/ErrorMessage';
import SelectorField from '@component_path/pages/common/form/element/select';
import { usePrefectureIdField } from '@component_path/inquiry_form_common_module/custom_hook/PrefectureId';

const props = defineProps({
  selectivePrefectureList: {
    type: Array,
    required: true
  }
});

const { validator, fieldName } = usePrefectureIdField(true);
const dispatcher = ref('positionInquiryMail/setPrefectureId');
const shouldDisplayError = useFieldError(fieldName.value);
</script>
